import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Samanage extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <polygon points="14.184 5.428 10.615 7.481 5.163 5.085 14.184 0 14.184 5.428" />
        <polygon points="19.139 18.739 4.861 10.68 4.861 5.261 19.139 13.32 19.139 18.739" />
        <polygon points="9.816 18.572 13.385 16.519 18.837 18.915 9.816 24 9.816 18.572" />
      </svg>
    );
  }
}

export default Samanage;
